"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Create an empty reference object.
 */
exports.newObject = function () { return ({
    classes: {},
    lastToken: 0
}); };
/**
 * Create a new reference object by removing the token from the provided
 * reference object.
 *
 * @param obj a previous reference object
 * @param token the reference id that needs removing
 */
exports.newObjectWithoutReferenceToToken = function (obj, token) { return ({
    classes: __assign({}, Object.entries(obj.classes)
        // Remove old, empty references.
        .filter(function (_a) {
        var _ = _a[0], values = _a[1];
        return values.length > 0;
    })
        // Remove the requested id.
        .map(function (_a) {
        var key = _a[0], values = _a[1];
        return [
            key,
            values.filter(function (v) { return v !== token; })
        ];
    })
        // Convert back to object from entries
        .reduce(function (acc, _a) {
        var key = _a[0], val = _a[1];
        var _b;
        return (__assign({}, acc, (_b = {}, _b[key] = val, _b)));
    }, {})),
    lastToken: obj.lastToken || 0
}); };
/**
 * Create a new reference object by:
 * 1. generating and adding a new token for the provided class name, to
 *    the provided reference object.
 * 2. saving the new token as lastToken
 *
 * @param obj a previous reference object
 * @param className the class name to claim a reference for
 */
exports.newObjectWithReferenceToClass = function (obj, className) {
    var _a;
    return ({
        classes: __assign({}, obj.classes, (_a = {}, _a[className] = (obj.classes[className] || []).concat([obj.lastToken + 1]), _a)),
        lastToken: obj.lastToken + 1
    });
};
//# sourceMappingURL=referenceObject.js.map